import './DashboardGrid.scss';
import { useRef, useEffect, CSSProperties, ReactNode } from 'react';
import { useDragActions, DropHandler } from './drag/DragContext';
import { DropMarker } from './drag/DropMarker';
import { GRID_COLUMNS, ROW_UNIT } from './dashboard-constants';

interface DashboardGridProps {
  zoneId: string | null;
  onDrop: DropHandler;
  // This grid's card ids in array order; see DropZone.cardIds.
  cardIds: string[];
  children?: ReactNode;
}

export const DashboardGrid = ({ zoneId, onDrop, cardIds, children }: DashboardGridProps) => {
  const { registerZone, unregisterZone } = useDragActions();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return undefined;
    registerZone(zoneId, { el: ref.current, onDrop, cardIds });
    return () => unregisterZone(zoneId);
  }, [zoneId, onDrop, cardIds, registerZone, unregisterZone]);

  return (
    <div
      ref={ref}
      className='dashboard-grid'
      // The column count and row unit both live in TS (every dimension is derived from them there)
      // and are handed to the CSS here rather than duplicated in the stylesheet.
      style={
        {
          '--dashboard-columns': GRID_COLUMNS,
          '--dashboard-row-unit': `${ROW_UNIT}px`
        } as CSSProperties
      }
    >
      <DropMarker zoneId={zoneId} />
      {children}
    </div>
  );
};
